import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { StorageService } from './storage.service';

import { environment } from 'src/environments/environment';
import { BehaviorSubject, map, pipe, of, catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  apiUrl: string = environment.apiUrl + '/login';
  TABLET_apiUrl: string = environment.tabletUrl + '/login';

  currentUser$ = new BehaviorSubject<any>(undefined);

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  login(credentials: { email: string; password: string }): Observable<any> {
    const body = {
      email: credentials.email,
      password: credentials.password,
    };

    return this.http.post(this.apiUrl, body);
  }

  loginTablet(credentials: {
    email: string;
    password: string;
  }): Observable<any> {
    const body = {
      email: credentials.email,
      password: credentials.password,
    };

    return this.http.post(this.TABLET_apiUrl, body);
  }

  checkAuth(): Observable<boolean> {
    const refreshToken = this.storageService.get('refreshToken', false);

    const TOKEN_apiUrl = environment.apiUrl + '/refresh-token';

    return this.http.post<any>(TOKEN_apiUrl, { refreshToken }).pipe(
      map((response: any) => {
        this.storageService.set('refreshToken', response.refreshToken);
        this.storageService.set('accessToken', response.accessToken);

        return true;
      }),
      catchError(() => of(false))
    );
  }
}
